<div class="p-6 max-w-7xl mx-auto space-y-6">
    <h1 class="text-2xl font-semibold text-slate-800 dark:text-slate-100">
        Profile
    </h1>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- User Information Card -->
        <div
            class="md:col-span-2 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 p-6">
            <h2
                class="text-lg font-medium text-slate-800 dark:text-slate-100 mb-6 border-b border-slate-100 dark:border-slate-700 pb-2">
                User Information
            </h2>

            <div class="space-y-4" *ngIf="user(); else loadingTpl">
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Date of Registration:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">
                        {{ (user()?.createdAt || user()?.registrationDate) | date:'mediumDate' }}
                    </span>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Name:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">
                        <ng-container *ngIf="user()?.firstName || user()?.lastName; else fullNameTpl">
                            {{ user()?.firstName }} {{ user()?.lastName }}
                        </ng-container>
                        <ng-template #fullNameTpl>
                            {{ user()?.name || (user()?.email ? user()?.email.split('@')[0] : 'N/A') }}
                        </ng-template>
                    </span>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Email:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">{{ user()?.email }}</span>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Role:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">
                        @if (roleLabel(); as role) {
                        <span class="inline-block rounded-full px-2.5 py-0.5 text-xs font-medium
                            bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-300">
                            {{ role }}
                        </span>
                        } @else {
                        N/A
                        }
                    </span>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Last Login:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">
                        {{ ($safeNavigationMigration(user()?.lastLoginAt) | date:'medium') || 'Just now' }}
                    </span>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <span class="text-sm font-medium text-slate-500 dark:text-slate-400">2FA Status:</span>
                    <span class="text-sm text-slate-900 dark:text-slate-200 sm:col-span-2">
                        <span *ngIf="user()?.isTwoFAEnabled || user()?.isTwoFactorEnabled"
                            class="text-green-600 font-medium">Enabled</span>
                        <span *ngIf="!(user()?.isTwoFAEnabled || user()?.isTwoFactorEnabled)"
                            class="text-slate-600">Disabled</span>
                    </span>
                </div>
            </div>

            <ng-template #loadingTpl>
                <div class="animate-pulse space-y-4">
                    <div class="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/4"></div>
                    <div class="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/2"></div>
                    <div class="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/3"></div>
                </div>
            </ng-template>
        </div>

        <!-- Actions Card -->
        <div
            class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 p-6 h-fit">
            <h2
                class="text-lg font-medium text-slate-800 dark:text-slate-100 mb-6 border-b border-slate-100 dark:border-slate-700 pb-2">
                Actions
            </h2>

            <div class="space-y-3">
                <button (click)="openProfileModal()"
                    class="w-full text-left px-4 py-2 text-sm text-indigo-600 dark:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 rounded-md transition-colors font-medium">
                    Update Profile
                </button>
                <button (click)="openPasswordModal()"
                    class="w-full text-left px-4 py-2 text-sm text-indigo-600 dark:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 rounded-md transition-colors font-medium">
                    Change Password
                </button>
            </div>
        </div>
    </div>

    <app-request-products></app-request-products>
</div>

<!-- Update Profile Modal -->
<div *ngIf="showProfileModal()"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity">
    <div
        class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900 dark:text-white">
                Update Profile
            </h3>
            <button (click)="closeProfileModal()"
                class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">
                <app-icon name="x" [size]="20"></app-icon>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6">
            <form [formGroup]="profileForm" class="space-y-4">

                <div class="grid grid-cols-2 gap-4">
                    <app-input label="First Name" type="text" placeholder="First Name"
                        formControlName="firstName"></app-input>

                    <app-input label="Last Name" type="text" placeholder="Last Name"
                        formControlName="lastName"></app-input>
                </div>

                <div class="flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-700/30 rounded-lg">
                    <div>
                        <h4 class="text-sm font-medium text-slate-800 dark:text-slate-100">Two-Factor Authentication
                        </h4>
                        <p class="text-xs text-slate-500 dark:text-slate-400">Enable 2FA for enhanced security</p>
                    </div>
                    <app-toggle formControlName="isTwoFAEnabled"></app-toggle>
                </div>

            </form>
        </div>

        <!-- Footer -->
        <div
            class="px-6 py-4 border-t border-slate-200 dark:border-slate-700 flex justify-end gap-3 bg-slate-50 dark:bg-slate-800/50">
            <app-button variant="outline" (click)="closeProfileModal()">
                Cancel
            </app-button>
            <app-button variant="default" [disabled]="profileForm.invalid || isSubmitting()"
                (click)="onProfileUpdateSubmit()">
                Save Changes
            </app-button>
        </div>
    </div>
</div>

<!-- Change Password Modal -->
<div *ngIf="showPasswordModal()"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity">
    <div
        class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900 dark:text-white">
                Change Password
            </h3>
            <button (click)="closePasswordModal()"
                class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">
                <app-icon name="x" [size]="20"></app-icon>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6">
            <form [formGroup]="passwordForm" class="space-y-4">

                <app-input label="Current Password*" type="password" placeholder="Enter current password"
                    formControlName="currentPassword" [showPasswordToggle]="true"
                    [error]="getError('currentPassword')"></app-input>

                <app-input label="New Password*" type="password" placeholder="Enter new password"
                    formControlName="newPassword" [showPasswordToggle]="true"
                    [error]="getError('newPassword')"></app-input>

                <app-input label="Confirm New Password*" type="password" placeholder="Confirm new password"
                    formControlName="confirmPassword" [showPasswordToggle]="true"
                    [error]="getError('confirmPassword')"></app-input>

            </form>
        </div>

        <!-- Footer -->
        <div
            class="px-6 py-4 border-t border-slate-200 dark:border-slate-700 flex justify-end gap-3 bg-slate-50 dark:bg-slate-800/50">
            <app-button variant="outline" (click)="closePasswordModal()">
                Cancel
            </app-button>
            <app-button variant="default" [disabled]="passwordForm.invalid || isSubmitting()"
                (click)="onChangePasswordSubmit()">
                Confirm
            </app-button>
        </div>
    </div>
</div>